export enum ViewMode {
    NORMAL = 'NORMAL',
    FULL_SCREEN = 'FULL_SCREEN',
    RIGHT_PANEL = 'RIGHT_PANEL'
}
